import IntegrationItemsFilter from './IntegrationItemsFilter';

export default IntegrationItemsFilter;
